import { Box, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTransactionTypeSelectorStyles } from 'components/TeamOverview/BillingSection/views/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const TransactionTypeSelector = ({
  currentTabValue,
  handleTabChange,
  tabsList,
}) => {
  const { classes } = useTransactionTypeSelectorStyles();

  return (
    <Box className={classes.tabsWrapper}>
      <Tabs
        value={currentTabValue}
        onChange={handleTabChange}
        indicatorColor="primary"
        classes={{
          root: classes.tabs,
          indicator: classes.indicator,
        }}
      >
        {tabsList.map((tab) => (
          <Tab
            key={tab.label}
            classes={{
              root: classes.tab,
              selected: classes.selectedTab,
            }}
            value={tab.value}
            label={
              <Tooltip title={tab.tooltip}>
                <Box className={classes.tabLabelContainer}>
                  {tab.tooltip ? (
                    <InfoOutlinedIcon className={classes.infoIcon} />
                  ) : (
                    <Box />
                  )}
                  <Typography className={classes.tabLabel}>
                    {tab.label}
                  </Typography>
                </Box>
              </Tooltip>
            }
          />
        ))}
      </Tabs>
    </Box>
  );
};
